import Vue from 'vue'
import HoneybadgerVue from '@honeybadger-io/vue'

const config = {
  apiKey: 'e2283651',
  environment: process.env.NODE_ENV,
  revision: 'master',
  beforeNotify: (notice) => {
    const fromExtension = notice.backtrace &&
      notice.backtrace.some(frame => frame.file && frame.file.startsWith('chrome-extension://'))
    if (fromExtension) return false

    const fromTreeselect = notice.backtrace &&
      notice.backtrace.some(frame => frame.method === 'getMenu' || frame.method === 'restoreMenuScrollPosition')
    if (fromTreeselect) return false
  }
}

if (process.env.NODE_ENV !== 'development') {
  Vue.use(HoneybadgerVue, config)
}
